<template>
  <div class="final-arrival">
    <div class="transfer-line-container" style="position: relative; height: 60px">
      <div class="final-arrival-line"></div>
      <i class="icon icon-record-fill station-marker fs-5" style="bottom: 0"></i>
    </div>

    <div class="duration">+{{ punctualityLimitDuration.asMinutes() }}min</div>

    <div class="score my-2">
      Pünktlichkeit:
      <arrival-score
        class="px-2 py-1 rounded border"
        :prediction="prediction"
        :inline="true"
      ></arrival-score>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type DelayPrediction } from '~/types/fptfTypes'
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'
import ArrivalScore from '~/components/JourneyDisplay/ArrivalScore.vue'

const store = useMainStore()
const { punctualityLimitDuration } = storeToRefs(store)

const props = defineProps<{
  prediction: DelayPrediction
  arrivalTime: string
}>()
</script>

<style lang="scss">
.final-arrival {
  display: grid;
  gap: 5px;
  padding: 15px;
  grid-template-columns: $time_col_width $fancy_line_width 1fr;
  grid-template-areas: 'duration fancy-line score';
}

.final-arrival-line {
  border: 1px dashed $gray-500;
  align-self: flex-end;
  z-index: 1;
  height: 16ch;
  margin-bottom: 30px;
}
</style>
